import { Link } from "wouter";
import { ArrowRight, Layers } from "lucide-react";
import type { CalculatorCategory, SuperCategoryGroup } from "@/data/calculators";
import { withTrailingSlash } from "@/lib/urls";

export function CategoryCard({ category, count }: { category: CalculatorCategory; count: number }) {
  return (
    <Link href={withTrailingSlash(`/category/${category.slug}`)} className="category-card">
      <Layers size={22} />
      <h3>{category.name}</h3>
      <p>{category.summary}</p>
      <span>{count} calculators <ArrowRight size={15} /></span>
    </Link>
  );
}

export function SuperCategoryCard({
  group,
  count,
  subCategories,
}: {
  group: SuperCategoryGroup;
  count: number;
  subCategories: CalculatorCategory[];
}) {
  return (
    <Link
      href={withTrailingSlash(`/calculators/${group.slug}`)}
      className="super-category-card"
      style={{ "--sc-color": group.color } as React.CSSProperties}
    >
      <div className="sc-header">
        <span className="sc-emoji" aria-hidden="true">{group.emoji}</span>
        <div>
          <h3 className="sc-title">{group.name}</h3>
          <span className="sc-count">{count} calculators</span>
        </div>
      </div>
      <p className="sc-desc">{group.description}</p>
      <div className="sc-cats">
        {subCategories.map((cat) => (
          <span key={cat.slug} className="sc-cat-pill">{cat.name}</span>
        ))}
      </div>
      <span className="sc-cta">Explore collection <ArrowRight size={14} /></span>
    </Link>
  );
}
